import React from "react";
import PropTypes from "prop-types";
import { OrderedMap, Map, List } from "immutable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, Modal, Button, PageHeader, Upload, Icon, Popconfirm, Switch } from "antd";
import {
    dispatchAction
} from "./../create-actions";
import BankAccountActions from "../constants/actions";
import { Table } from "components/table";
import cx from "classnames";
import { readSpreadsheet } from "utilities/excel-utils";
import AddLendingPartnerAccount from "./../forms/add-lending-partner-account";
import BankAccountService from "./../services";
import {
    BANK_ACCOUNT_TYPES
} from "constants/enums";
import { LenderAccountRecord } from "./../records";
import BANK_LOGO from "assets/bank-icon.png";
import "styles/table.css";

const { Dragger } = Upload;

const TABLE_COLUMNS = new OrderedMap({
    account_number: {
        key: "account_number",
        title: "Account No",
        dataIndex: "account_number",
        width: 150,
        align: "center"
    },
    account_holder_name: {
        key: "account_holder_name",
        title: "Account Holder",
        dataIndex: "account_holder_name",
        width: 200,
        align: "center",
    },
    partner_bank: {
        key: "partner_bank",
        title: "Lending Partner",
        dataIndex: "partner_bank",
        width: 100,
        align: "center",
        render: _ => (_ &&  _.code) || "--"
    },
    account_type: {
        key: "account_type",
        title: "Account Type",
        dataIndex: "account_type",
        width: 150,
        align: "center",
        render: _ => BANK_ACCOUNT_TYPES.findKey(__ => _ == __)
    },
    status: {
        key: "status",
        title: "Status",
        dataIndex: "status",
        width: 100,
        align: "center",
        render: _ => _ && (_ == 1 ? "Active" : "InActive") || "--"
    },
    action: {
        key: "action",
        title: "Actions",
        dataIndex: "action",
        width: 250,
        align: "center"
    }
});
class LendersAccountsList extends React.Component {

    state = {
        editing: false,
        editStatus: false,
        selectedAccount: null,
        currentPage: 1,
        lending_partners: [],
        selectedStatus: null,
        excel_data: []
    }

    pageSize = 15;

    filters = {};

    componentDidMount() {
        this.props.dispatchAction(
            BankAccountActions.LENDER_ACCOUNTS.LIST.FETCH,
            {
                page: this.state.currentPage,
                page_size: this.pageSize,
                filters: JSON.stringify(this.filters)
            }
        );
        BankAccountService.getLendingPartners().then(({data}) => {
            this.setState({
                lending_partners: data
            });
        }).catch(() => {});
    }

    componentDidUpdate() {
        if(
            this.props.createUpdateLenderAccountStatus &&
            ["CREATED", "UPDATED"].includes(this.props.createUpdateLenderAccountStatus)
        ) {
            this.props.dispatchAction(
                BankAccountActions.LENDER_ACCOUNTS.LIST.FETCH,
                {
                    page: 1,
                    page_size: this.pageSize,
                    filters: JSON.stringify(this.filters)
                }
            );
        }
    }

    addBankAccountDetails = (values) => {
        if(this.state.selectedAccount) {
            this.props.dispatchAction(
                BankAccountActions.LENDER_ACCOUNTS.ACCOUNT.UPDATE,
                null,
                [new LenderAccountRecord(values).JSONValues]
            );
        } else {
            this.props.dispatchAction(
                BankAccountActions.LENDER_ACCOUNTS.ACCOUNT.CREATE,
                null,
                [new LenderAccountRecord(values).JSONValues]
            );
        }
        this.toggleEditModal();
    }

    uploadExcelData = () => {
        this.props.dispatchAction(
            BankAccountActions.LENDER_ACCOUNTS.ACCOUNT.CREATE,
            null,
            this.state.excel_data && this.state.excel_data.map(_ => {
                return {
                    ..._,
                    account_entity_type: 1,
                    is_key_account: false
                };
            })
        );
    }

    createUpdateBankAccount = () => {
        return (
            <Modal
                visible={this.state.editing}
                closable={true}
                width={800}
                destroyOnClose={true}
                footer={null}
                onCancel={this.toggleEditModal}
            >
                <AddLendingPartnerAccount
                    partner_banks={this.state.lending_partners}
                    onValuesSubmit={this.addBankAccountDetails}
                    closeModal={this.toggleEditModal}
                    bankDetails={this.state.selectedAccount}
                />
            </Modal>
        );
    }

    updateBankAccount = () => {
        this.props.dispatchAction(
            BankAccountActions.LENDER_ACCOUNTS.ACCOUNT.UPDATE,
            null,
            [{...this.state.selectedAccount.JSONValues, status: this.state.selectedStatus}]
        );
    }

    onSelectAccountStatus = (account, e) => {
        this.setState({
            selectedAccount: account,
            selectedStatus: e ? 1 : 2
        }, () => this.updateBankAccount());
    }

    // updateBankAccountStatus = () => {
    //     return (
    //         <Modal
    //             title={
    //                 <span style={{ fontWeight: "bold" }}>
    //                     {"Update Account Status"}
    //                 </span>
    //             }
    //             width={"350px"}
    //             visible={this.state.editStatus}
    //             closable={true}
    //             destroyOnClose={true}
    //             footer={null}
    //             onCancel={this.toggleEditStatusModal}
    //         >
    //             <div className={"d-flex flex-column"}>
    //                 <Select
    //                     placeholder={"Select Account Status"}
    //                     style={{
    //                         width: "300px"
    //                     }}
    //                     value={this.state.selectedStatus}
    //                     onSelect={this.onSelectAccountStatus}
    //                 >
    //                     <Select.Option value={"1"}>
    //                         {"Active"}
    //                     </Select.Option>
    //                     <Select.Option value={"2"}>
    //                         {"In-Active"}
    //                     </Select.Option>
    //                 </Select>
    //                 <div className={"mt-10"}>
    //                     <Button block type={"primary"} onClick={this.updateBankAccount}>
    //                         {"Update"}
    //                     </Button>
    //                 </div>
    //             </div>
    //         </Modal>
    //     );
    // }

    readFile = async (file) => {
        let data = await readSpreadsheet(file);
        data = new List(data);
        this.setState({
            excel_data: data,
        });
    };

    downloadSampleSheet = () => {
        return import(/* webpackChunkName: "xlsx" */ "xlsx")
            .then(_ => _.default)
            .then(async XLSX => {
                let ws = await XLSX.utils.json_to_sheet([], {header: ["company_gstin", "account_type", "ifsc_code", "account_holder_name", "account_number", "fi_code", "fi_account_number"]});
                let wb = await XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
                const wbout = XLSX.writeFile(wb, "sample-bank-account.xlsx");
                return wbout;
            });
    }

    excelUploadModal = () => {
        return (
            <Modal
                title={
                    <span style={{ fontWeight: "bold" }}>
                        {"Upload Excel For Bulk Account Creation"}
                    </span>
                }
                width={"500px"}
                visible={this.state.showExcelUpload}
                closable={true}
                destroyOnClose={true}
                footer={null}
                onCancel={this.toggleUploadModal}
            >
                <div className={"p-10 d-flex flex-column"}>
                    <Dragger
                        name={"file"}
                        multiple={false}
                        action={null}
                        beforeUpload={(file) => {
                            this.readFile(file);
                        }}
                    >
                        <p className="ant-upload-drag-icon">
                            <Icon type="inbox" />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    </Dragger>
                    <div className={"mt-10 d-flex justify-content-space-between"}>
                        <Button icon={"download"} type={"dashed"} onClick={this.downloadSampleSheet}>
                            {"Download Sample file"}
                        </Button>
                        <Button icon={"upload"} type={"primary"} onClick={this.uploadExcelData}>
                            {"Upload File"}
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }

    toggleEditModal = (account) => {
        this.setState({
            editing: !this.state.editing,
            selectedAccount: account
        });
    }

    toggleEditStatusModal = (account) => {
        this.setState({
            editStatus: !this.state.editStatus,
            selectedAccount: account,
            selectedStatus: account.status && String(account.status)
        });
    }

    onPageChange = (page) => {
        this.setState(
            {
                currentPage: page
            },
            () => {
                this.props.dispatchAction(
                    BankAccountActions.LENDER_ACCOUNTS.LIST.FETCH,
                    {
                        page: this.state.currentPage,
                        page_size: this.pageSize,
                        filters: JSON.stringify(this.filters)
                    }
                );
            }
        );
    };

    onPageSizeChange = (page, pageSize) => {
        this.setState(
            {
                currentPage: page
            },
            () => {
                this.pageSize = pageSize;
                this.props.dispatchAction(
                    BankAccountActions.LENDER_ACCOUNTS.LIST.FETCH,
                    {
                        page: this.state.currentPage,
                        page_size: this.pageSize,
                        filters: JSON.stringify(this.filters)
                    }
                );
            }
        );
    };

    handleItemClick = () => {
        this.toggleEditModal();
    }

    toggleUploadModal = () => {
        this.setState({
            showExcelUpload: !this.state.showExcelUpload
        });
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <PageHeader 
                            ghost={false}
                            title={"Lenders Accounts Section"}
                            onBack={() => this.props.history.goBack()}
                            avatar={{ src: BANK_LOGO }}
                            extra={[
                                <Button key={"create"} type={"primary"} onClick={this.handleItemClick}>{"Add Account"}</Button>,
                                <Button key={"upload-excel"} icon={"excel"} onClick={this.toggleUploadModal}>Upload Excel File</Button>
                            ]}
                        >
                        </PageHeader>
                    </Col>
                    <Col style={{ padding: "48px 120px"}}>
                        <Table
                            title={<span style={{
                                display: "flex",
                                alignItems: "center",
                                fontWeight: "bold",
                                lineHeight: "32px",
                                fontSize: "16px"
                            }}>{"Bank Account List"}</span>}
                            size={"small"}
                            type={"inner"}
                            className={cx("bank-account-table")}
                            bordered={true}
                            columns={TABLE_COLUMNS.filter(_ => !this.props.editPermission ? _.key !== "action" : null)}
                            data={this.props.lenderAccounts.map(_ => {
                                let row = _;
                                if(this.props.editPermission) {
                                    row.action = (
                                        <React.Fragment>
                                            <Button type={"link"} classname={"mr-10"} onClick={this.toggleEditModal.bind(null, _)} icon={"edit"}>Edit</Button>
                                            <Popconfirm
                                                onConfirm={this.onSelectAccountStatus.bind(null, _, !_.status)}
                                                onCancel={() => this.forceUpdate()}
                                                okText={"Yes"}
                                                cancelText={"No"}
                                                title={`Are you sure, you want to ${_.status == 1 ? "Deactivate" : "Activate"} the account?`}
                                            >
                                                <Switch
                                                    defaultChecked={_.status == 1}
                                                />
                                            </Popconfirm>
                                        </React.Fragment>
                                    );
                                }
                                return row;
                            }).toList()}
                            rowKey={"id"}
                            noRowSelection={true}
                            loading={this.props.loading}
                            showFilters={false}
                            fixedColsRight={["action"]}
                            showColumnSelector={false}
                            tablePagination={false}
                            pagination={{
                                current: this.state.currentPage,
                                showSizeChanger: true,
                                defaultPageSize: 15,
                                total: this.props.totalLendersAccount,
                                pageSizeOptions: [
                                    "15",
                                    "20",
                                    "50",
                                    "100",
                                    "500"
                                ],
                                position: "bottom",
                                onChange: (page, pageSize) =>
                                    this.onPageChange(page, pageSize),
                                onShowSizeChange: this.onPageSizeChange
                            }}
                        />
                    </Col>
                </Row>
                {this.createUpdateBankAccount()}
                {/* {this.updateBankAccountStatus()} */}
                {this.excelUploadModal()}
            </React.Fragment>
        );
    }
}

LendersAccountsList.propTypes = {
    route: PropTypes.object,
    history: PropTypes.object,
    dispatchAction: PropTypes.func,
    lenderAccounts: PropTypes.object,
    loading: PropTypes.bool,
    totalLendersAccount: PropTypes.number,
    createUpdateLenderAccountStatus: PropTypes.string,
    editPermission: PropTypes.bool
};

LendersAccountsList.defaultProps = {
    lenderAccounts: new Map({}),
    totalLendersAccount: 0,
    createUpdateLenderAccountStatus: null
};

const filterBankAccountsData = (data, ids) => {
    if(ids) {
        return data.filter(_ => ids.toArray().includes(_.id));
    }
    return data;
};

const mapStateToProps = (state) => {
    const currentPage = state.bankAccount && state.bankAccount.lenderAccounts.getIn(["pagination", "page"]);
    const currentPageIds = state.bankAccount && state.bankAccount.lenderAccounts.getIn(["pages", currentPage]);
    return {
        lenderAccounts: filterBankAccountsData(state.bankAccount.lenderAccounts.getIn(["data"]), currentPageIds),
        loading: state.bankAccount.lenderAccounts.getIn(["loading"]),
        totalLendersAccount: state.bankAccount.lenderAccounts.getIn(["pagination", "totalCount"]),
        createUpdateLenderAccountStatus: state.bankAccount.lenderAccounts.getIn(["createUpdate", "status"]),
        editPermission: state.user.getIn(["permissions", "edit_bank_accounts"])
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    dispatchAction
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps) (LendersAccountsList);